export default __webpack_public_path__ + "static/media/balance-sheet-and-capital-structure-3.a4795007.png";